import React from 'react';
import PropTypes from 'prop-types';
import { Link, StaticQuery, graphql } from 'gatsby';

import best2024 from '../images/best2024.jpeg';
import best2025 from '../images/best2025.jpeg';
import best2026 from '../images/best2026.jpeg';
import bodywork1 from '../images/bodywork1.jpeg';
import bodywork2 from '../images/bodywork2.jpeg';
import dario2 from '../images/dario2.jpeg'
import ryan from '../images/ryan.jpeg'
import bucky from '../images/bucky.jpeg'
import together from '../images/together.jpeg'

import Cta from './cta';
import Waves from './waves';
import Navigation from './navigation';
import Footer from './footer';

import '../css/typography.css';

function Layout({ children }) {
    return (
        <StaticQuery
            query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title,
              github,
              blog
            }
          }
        }
      `}
            render={data => (
                <body className="leading-normal tracking-normal text-white gradient">
                    {children}
                    <Navigation />

                    {/* Hero */}
                    <div className="pt-40 hero">
                        <div className="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center">
                            <div className="tenor flex pb-12 flex-col w-full md:w-2/5 justify-center items-center sm:items-start text-center md:text-left">
                                <h1 className="my-4 text-3xl sm:text-4xl font-bold leading-tight bg-black bg-opacity-50 p-6 rounded">Bodywork designed<br /> to make your body<br /><span className="text-5xl sm:text-6xl" style={{color: 'rgba(121, 217, 215)'}}>work.</span></h1>
                                <div className="flex">
                            </div>
                            </div>
                        </div>
                        <Waves />
                    </div>

                    {/* Main Blurbs */}
                    <section className="bg-white border-b pt-8">
                        <div className="container max-w-5xl mx-auto">

                            <div className="flex flex-wrap justify-center py-10 md:py-20">
                                <div className="w-full md:w-1/2 px-8">
                                    <h3 className="text-xl sm:text-3xl text-gray-800 font-bold mb-3">Targeted Pain Relief for Peak Performance and Ultimate Relaxation</h3>
                                    <p className="text-gray-600 mb-4">Mexía Bodywork is THE total physique solution designed to restore youthful movement, energy, and well-being. Utilizing the world’s most advanced  techniques, Dario Mexia heals pain at its root and rejuvenates your body.</p>
                                    <Link to="/treatments" className="text-blue-500 mb-4 inline-block" href="#">Look at our available treatments.</Link>
                                </div>
                                <div className="w-full md:w-1/2 px-8">
                                    <img className="imageFilter rounded-lg" src={bodywork1} />
                                </div>
                            </div>

                            <div className="flex flex-wrap justify-center py-10 md:py-20">
                                <div className="w-full md:w-1/2 px-8 mb-4">
                                    <img className="imageFilter rounded-lg" src={bodywork2} />
                                </div>
                                <div className="w-full md:w-1/2 px-8">
                                    <div className="align-middle">
                                        <h3 className="text-xl sm:text-3xl text-gray-800 font-bold mb-3">Body Work Designed To Make Your Body Work</h3>
                                        <p className="text-gray-600 mb-8">Bodywork is a transformative form of physical care that synthesizes the best of massage therapy, healing cupping and assisted stretching exercises to give your body the relief it needs to perform at its absolute best.
                                            It’s more than just another trip to the massage parlor. It’s a total body transformation for relief that lasts.</p>
                                        <Link to="/treatments" className="text-blue-500" href="#">Learn about the benefits of bodywork.</Link>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row py-10 md:py-20">
                                <div className="w-full md:w-1/2 px-8 py-4">
                                    <h3 className="text-xl sm:text-3xl text-gray-800 font-bold mb-3">Best of DC three years in a row</h3>
                                    <p className="text-gray-600 mb-4">Mexía Bodywork was recently voted Best of DC for "Best Therapeutic Massage". Thanks to the DMV community for supporting our small business and allowing us to provide compassionate, best-in-class service.</p>
                                    <Link to="https://bestof2024.washingtoncitypaper.com/goods-and-services-readers-picks/best-therapeutic-massage" target="_blank" className="text-blue-500" href="https://bestof2024.washingtoncitypaper.com/goods-and-services-readers-picks/best-therapeutic-massage">Best of DC 2024</Link>
                                    <br />
                                    <Link to="https://bestof2025.washingtoncitypaper.com/goods-and-services/best-massage" target="_blank" className="text-blue-500" href="https://bestof2025.washingtoncitypaper.com/goods-and-services/best-massage">Best of DC 2025</Link>
                                    <br />
                                    <Link to="https://bestof2026.washingtoncitypaper.com/goods-and-services/best-massage" target="_blank" className="text-blue-500" href="https://bestof2026.washingtoncitypaper.com/goods-and-services/best-massage">Best of DC 2026</Link>
                                </div>
                                <div className="w-full md:w-1/2 px-8 py-4">
                                    <img className="imageFilter rounded-lg" src={best2026} />
                                </div>
                            </div>

                            <div className="flex flex-wrap justify-center py-10 md:py-20">
                                <div className="w-full md:w-1/2 px-8 mb-4">
                                    <img className="imageFilter rounded-lg" src={together} />
                                </div>
                                <div className="w-full md:w-1/2 px-8">
                                    <div className="align-middle">
                                        <h3 className="text-xl sm:text-3xl text-gray-800 font-bold mb-3">Meet Our Team!</h3>
                                        <p className="text-gray-600 mb-8">Our team is growing due to increasing demand but the quality of our services and our commitment to satisfaction remains the same. Every one is built differently and we are here to help you find the kind of custom bodywork that is right for you.</p>
                                        <Link to="/booking" className="text-blue-500" href="#">Book your appointment today</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Reviews */}
                    <section className="bg-white border-b pt-8 px-8 md:px-0">
              
                        <div className="container mx-auto flex flex-wrap pt-4 pb-12">
                            <h1 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">Latest Reviews</h1>
                            <div className="w-full mb-4">
                                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                            </div>
                            <div className="w-full mt-12">
                                <div className="elfsight-app-5e11d1e3-983a-4da6-9dbe-5c87b1cdaa58"></div>
                            </div>
                        </div>

                    </section>

                    {/* Mission */}
                    <section className="bg-gray-100 py-8">

                        <div className="container max-w-5xl mx-auto px-2 py-4 text-gray-800">
                            <h1 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">Our Cause & Mission</h1>
                            <div className="w-full mb-4">
                                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                            </div>

                            <div className="flex flex-col md:flex-row justify-center items-center sm:my-4">
                                <div className="w-full md:w-1/2 p-6">
                                    <p>
                                        Here at Mexia Massage and Bodywork, our cause is to enable people to experience an ever greater comfort in their own bodies, where well-being is restored, nurtured, and sustained indefinitely.
                                    </p>
                                    <br />
                                    <p>
                                        Our goal is to help you move better, feel better, and live pain free. You are the reason we continue to learn and refine our craft, always striving to provide the most effective and advanced care possible. Through Mexia Massage & Bodywork, we create personalized treatment plans tailored to your unique needs so you can get back to doing what you love, stronger than ever.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </section>

                    {/* About section */}
                    <section id="specialists" className="bg-gray-100 py-8">
              
                        <div className="container max-w-5xl mx-auto px-2 py-4 text-gray-800">
                            <h1 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">Your Specialists</h1>
                            <div className="w-full mb-4">
                                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                            </div>

                            <div className="flex flex-col md:flex-row justify-center items-center sm:my-4">
                                <div className="md:w-1/2 p-6">
                                    <img className="imageFilter rounded-lg mx-auto max-h-96" src={dario2} alt="Dario Mexia" />
                                </div>
                                <div className="w-full md:w-1/2 p-6">
                                    <p className="text-2xl font-bold leading-tight text-center text-gray-800">
                                        Dario
                                    </p>
                                    <br />
                                    <p>
                                        Dario Mexia is not your average massage therapist. His last name, "Mexia," comes from an old Spanish variant meaning "medicine" or "healer" , a fitting legacy that fuels his passion for helping others move, feel, and perform at their best.
                                    </p>
                                    <br />
                                    <p>
                                        Originally from Colombia, Dario earned a Bachelor's degree in Economics before moving to the U.S. in 2012. However, his true calling led him to the world of manual therapy and bodywork. After completing a massage therapy program and becoming a certified personal trainer, he has continued to refine his craft through advanced training in Structural Integration, Myofascial Release, Fascia Stretch Therapy , Cupping Therapy (a.k.a Myofascial Decompression), Scraping Therapy, Sports Massage and Medical Massage.
                                    </p>
                                    <br />
                                    <p>
                                        As a former semi-professional volleyball player, Dario understands the demands placed on the body whether you're an athlete, an active professional, or someone dealing with chronic tension. His approach goes beyond relaxation; he specializes in restoring mobility, relieving pain, and optimizing performance through customized, hands-on techniques.
                                    </p>
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row justify-center items-center sm:my-4">
                                <div className="md:w-1/2 p-6">
                                    <img className="imageFilter rounded-lg mx-auto max-h-96" src={ryan} alt="Ryan Holbert" />
                                </div>
                                <div className="w-full md:w-1/2 p-6">
                                    <p className="text-2xl font-bold leading-tight text-center text-gray-800">
                                        Ryan
                                    </p>
                                    <br />
                                    <p>
                                        Ryan Holbert is a licensed massage therapist, bodyworker, and certified Accufit Therapist with a deep passion for helping others feel better in their bodies because he knows firsthand what it means to rebuild from the ground up.
                                    </p>
                                    <br />
                                    <p>
                                        With over a decade of experience in massage and bodywork, Ryan draws from a diverse background that blends clinical knowledge with intuitive touch. His approach is deeply informed by both science and personal transformation. Years ago, Ryan faced a life-altering diagnosis: a brain tumor that left him relearning how to walk, move, and reconnect with his own body. That journey, filled with physical therapy, resilience, and self-discovery, reshaped not only his life but also his philosophy as a healer.
                                    </p>
                                    <br />
                                    <p>
                                        Ryan specializes in therapeutic massage, neuromuscular techniques, and advanced bodywork for pain relief, injury recovery, and performance optimization. He’s particularly skilled at working with athletes, chronic pain clients, and those navigating post-surgical or neurological recovery. His training in Accufit therapy allows him to offer a cutting-edge, non-invasive approach to muscle activation and strengthening.
                                    </p>
                                    <br />
                                    <p>
                                        Clients often say Ryan brings a rare combination of strength, sensitivity, and presence to the table - someone who truly listens to the body and meets it where it is. Whether you’re in need of deep restorative work or focused therapeutic care, Ryan’s work is rooted in empathy, precision, and purpose.
                                    </p>
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row justify-center items-center sm:my-4">
                                <div className="md:w-1/2 p-6">
                                    <img className="imageFilter rounded-lg mx-auto max-h-96" src={bucky} alt="Bucky" />
                                </div>
                                <div className="w-full md:w-1/2 p-6">
                                    <p className="text-2xl font-bold leading-tight text-center text-gray-800">
                                        Bucky
                                    </p>
                                    <br />
                                    <p>
                                        With over a decade of experience in the health and wellness space, Bucky brings a holistic, integrated approach shaped by his work as a personal trainer, yoga teacher, and somatic healing guide. Drawing from a range of tools—including breathwork, vinyasa-style yoga, and therapeutic bodywork—his sessions support overall wellness by tending to the body, mind, and nervous system as a whole.
                                    </p>
                                    <br />
                                    <p>
                                        Known for his soft, grounded presence, Bucky creates a space where clients feel safe to unwind, release tension, and restore balance in their own natural rhythm. Through a blend of mindful movement, conscious breathing, and intuitive touch, he encourages deeper awareness and connection within the body.
                                    </p>
                                    <br />
                                    <p>
                                        Rather than forcing change, his work emphasizes allowing—meeting each person exactly where they are. Whether through gentle flow, guided breathwork, or targeted massage, each session is thoughtfully tailored to support ease, resilience, and lasting well-being.
                                    </p>
                                    <br />
                                    <p>
                                        Outside of his work, Bucky is an avid reader, home cook, and world traveler, drawing inspiration from these passions to enrich both his life and the experiences he offers.
                                    </p>

                                </div>
                            </div>
                        </div>
                
                    </section>

                    {/* Instagram */}
                    <section className="bg-white py-8">
                        <h1 className="w-full my-2 text-3xl font-bold leading-tight text-center text-gray-800">Instagram</h1>
                        <div className="w-full mb-4">
                            <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
                        </div>
                        <div className="container max-w-5xl mx-auto px-2 pt-4 text-gray-800">
                            <div className="elfsight-app-b25e1d9e-e0e8-4786-86be-aa1e66d3a735"></div>
                        </div>
                    </section>

                    <Cta />
                    <Footer />

                </body>
            )}
        />
    );
}

Layout.propTypes = {
    children: PropTypes.node.isRequired
};

export default Layout;
